import { atom } from 'jotai';


const cartAtom = atom(
    localStorage.getItem('carrello') ? JSON.parse(localStorage.getItem('carrello')) : [], 
    (get, set, newCart) => {
        localStorage.setItem('carrello', JSON.stringify(newCart))
        set(cartAtom, newCart)
    }
);

const apriModaleLogin = atom(false);

const apriModaleRecuperPassword = atom(false);

const apriModaleLogout = atom(false);

// const utenteAtom = atom(
//     localStorage.getItem('utente') ? JSON.parse(localStorage.getItem('utente')) : {},
//     (get, set, newUtente) => {
//         localStorage.setItem('utente', JSON.stringify(newUtente))
//         set(utenteAtom, newUtente)
//     }
// );

const utenteAtom = atom({});

const loggatoAtom = atom({});

// const cartAtomWithPersistence = atom(
//     get => get(cartAtom),
//     (get, set, newCart) => {
//         set(cartAtom, newCart)
//         localStorage.setItem('carrello', JSON.stringify(newCart))
//     },
// )


const quantityAtom = atom((get) => get(cartAtom).reduce((acc, product) => acc + product.quantita, 0));

const totalPriceAtom = atom((get) => get(cartAtom).reduce((acc, product) => acc + (product.prodotto.prod_prezzo * product.quantita), 0));


export { cartAtom, quantityAtom, totalPriceAtom, apriModaleLogin, apriModaleRecuperPassword, apriModaleLogout, utenteAtom };